module.exports = __webpack_public_path__ + "static/Orbica-animation-1560ae64726ee2ff1d8a4cf7c2a3d4f4.mp4";